module.exports = __webpack_public_path__ + "static/media/bg_9.b2445bb4.jpg";